import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { iconButtonStyles } from '../../styles/commonStyles';
import ButtonWithIcon from './ButtonWithIcon';

const BackButton = ({ onClick }) => (
    <ButtonWithIcon
        Icon={FiArrowLeft}
        onClick={onClick}
        className={iconButtonStyles}
    />
);

export default BackButton;
